import {
  Box,
  Typography,
  Stack,
  Link,
  Divider,
  Grid,
  TextField,
  Button,
  useTheme,
  useMediaQuery
} from '@mui/material';

import contactLady from '../assets/image/contact-lady.png';

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>

   

      {/* ------------------------------------------------ */}
      {/*   EXISTING FOOTER (dark blue section)             */}
      {/* ------------------------------------------------ */}
      <Box
        component="footer"
        sx={{
          backgroundColor: '#ffbc00',
          color: '#0b0b0bff',
          borderTop: '1px solid #e2e8f0',
          px: 3,
          pt: 2,
          pb: 2,
          mt: 0, // remove gap since contact section is above
        }}
      >
        {/* Policy Links */}
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', sm: 'center' }}
          spacing={2}
          flexWrap="wrap"
        >
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            © {new Date().getFullYear()} Work Horse, Singapore. All rights reserved.
          </Typography>

          <Stack direction="row" spacing={2} flexWrap="wrap">
            <Link href="/Terms" underline="hover" color="inherit">Terms of Service</Link>
            <Divider orientation="vertical" flexItem />
            <Link href="/Privacy" underline="hover" color="inherit">Privacy Policy</Link>
            <Divider orientation="vertical" flexItem />
            <Link href="/contact-us" underline="hover" color="inherit">Contact Us</Link>
          </Stack>
        </Stack>

      </Box>
    </>
  );
};

export default Footer;
